<template>
  <div class="p-grid">
    <div class="p-col-12">
      <div class="card card-w-title">
        <div class="manager-title">{{ title }}</div>
      </div>
      <div class="card card-w-title">
        <div class="box-top-list">
          <span class="right-button view-detail">
            <Button class="p-button-warning" :label="'Quay lại'" @click="backList" />
          </span>
        </div>
        <div class="box-info p-fluid p-grid">
          <div class="p-col-6">
            <div class="box-info-title">{{(returnType > 0) ? 'SẢN PHẨM TRẢ':'SẢN PHẨM ĐỔI'}}</div>
            <div class="form-info">
              <div class="p-field">
                <label>Model sản phẩm</label>
                <span> {{ model_code }}</span>
              </div>
              <div class="p-field">
                <label>Tên sản phẩm</label>
                <span>{{ product_name }}</span>
              </div>
              <div class="p-field" v-if="returnType == 0">
                <label>Serial number</label>
                <span>{{ serialnumberText }}<abbr @click="serialNumberInfo(serial_number_id, request_activation_id, 'Serial number đổi')">(Xem chi tiết)</abbr></span>
              </div>
              <!--<div class="p-field" v-if="returnType == 0">
                <label>Serial number mới</label>
                <span>{{ serialnumberTextNew }}<abbr @click="serialNumberInfo(change_serial_number_product_id, change_request_activation_id, 'Serial number mới')">(Xem chi tiết)</abbr></span>
              </div>-->
              <div class="p-field" v-if="returnType > 0">
                <label>Serial number</label>
                <span>{{ serialnumberText }}<abbr @click="serialNumberInfo(serial_number_id, request_activation_id, 'Serial number trả')">(Xem chi tiết)</abbr></span>
              </div>
            </div>

            <div class="box-info-title" v-if="returnType == 0">SẢN PHẨM MỚI</div>
            <div class="form-info" v-if="returnType == 0">
              <div class="p-field">
                <label>Model sản phẩm</label>
                <span> {{ productModelcodeTextNew }}</span>
              </div>
              <div class="p-field">
                <label>Tên sản phẩm</label>
                <span>{{ productNameTextNew }}</span>
              </div>
              <!--<div class="p-field" v-if="returnType == 0">
                <label>Serial number đổi</label>
                <span>{{ serialnumberText }}<abbr @click="serialNumberInfo(serial_number_id, request_activation_id, 'Serial number đổi')">(Xem chi tiết)</abbr></span>
              </div>-->
              <div class="p-field" v-if="returnType == 0">
                <label>Serial number</label>
                <span>{{ serialnumberTextNew }}<abbr @click="serialNumberInfo(change_serial_number_product_id, change_request_activation_id, 'Serial number mới')">(Xem chi tiết)</abbr></span>
              </div>
              <!--<div class="p-field" v-if="returnType > 0">
                <label>Serial number trả</label>
                <span>{{ serialnumberText }}<abbr @click="serialNumberInfo(serial_number_id, request_activation_id, 'Serial number trả')">(Xem chi tiết)</abbr></span>
              </div>-->
            </div>

          </div>
          <div class="p-col-5 p-offset-1">
            <div class="box-info-title">{{ title_return }}</div>
            <div class="form-info">
              <div class="p-field">
                <label>Loại dịch vụ</label>
                <span>{{ serviceType }}</span>
              </div>
              <div class="p-field">
                <label>{{ titleDateChange }}</label>
                <span>{{ dateChange }}</span>
              </div>
              <div class="p-field">
                <label>{{ titleReasonChange }}</label>
                <span>{{ reasonChange }}</span>
              </div>
              <div class="p-field">
                <label>Lý do chi tiết</label>
                <span>{{ reasonDetail }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="box-top-list last-changed">
          <span class="p-m-0 format-title">LỊCH SỬ ĐỔI TRẢ VÀ THẨM ĐỊNH</span>
        </div>
        <div class="box-info log-changed">
          <div class="list-data">
            <BaseCommon v-if="dataModelLog"
              :key="componentKeyLog"
              :listData="listDataLog"
              :model="dataModelLog"
              :isFilter="false"
              :pagination="false"
            ></BaseCommon>
          </div>
        </div>
      </div>
    </div>
    <Dialog
      :header="dialogHeader"
      :visible.sync="displayDialog"
      :contentStyle="{overflow: 'visible'}"
      :style="{width: '50vw'}"
      :class="'popup-confirm'"
      :modal="true"
    >
      <div class="dialog-content">
        <div class="p-fluid">
          <div class="p-col-12 box-info form-popup-custom">
            <div class="form-info">
              <div class="p-field">
                <label>Trạng thái bảo hành</label>
                <span v-html="warranty_status"></span>
              </div>
              <div class="p-field">
                <label>Model sản phẩm</label>
                <span>{{ model_code_dialog }} </span>
              </div>
              <div class="p-field">
                <label>Tên sản phẩm</label>
                <span>{{ product_name_dialog }} </span>
              </div>
              <div class="p-field">
                <label>Serial number</label>
                <span>{{ serial_number }}</span>
              </div>
              <div class="p-field">
                <label>Nhóm sản phẩm</label>
                <span>{{ categories_name }}</span>
              </div>
              <div class="p-field">
                <label>Thời hạn bảo hành</label>
                <span v-html="warranty_time"></span>
              </div>
              <div class="p-field">
                <label>Thời hạn đổi</label>
                <span v-html="change_time"></span>
              </div>
              <div class="p-field">
                <label>Thời hạn trả</label>
                <span v-html="returnable_time"></span>
              </div>
              <div class="p-field">
                <label>Ngày sản xuất</label>
                <span>{{ created_date }}</span>
              </div>
              <div class="p-field">
                <label>Ngày bán sản phẩm</label>
                <span>{{ date_of_sale }}</span>
              </div>
              <div class="p-field">
                <label>Ngày kích hoạt bảo hành</label>
                <span>{{ activation_date }} </span>
              </div>
              <div class="p-field">
                <label>Ngày hết hạn bảo hành</label>
                <span>{{ expired_activation_date }}</span>
              </div>
            </div>
            <div class="text-center"><i>(Thời hạn bảo hành/ đổi/ trả được tính đến ngày đổi sản phẩm)</i></div>
          </div>
        </div>
      </div>
    </Dialog>
  </div>
</template>

<script>
import moment from "moment";
import DataServices from '@/core/DataServices'
import BaseCommon from '../common'
export default {
  components: {
    BaseCommon
  },
  data() {
    return {
      listData: [],
      dataModel: null,
      listDataLog: [],
      dataModelLog: null,
      componentKey: 0,
      componentKeyLog: 0,
      title: 'Chi tiết thông tin đổi',
      title_return: 'THÔNG TIN ĐỔI',
      request_return_product_id: 0,
      user_id: 0,
      request_id: 0,
      model_code: '',
      product_name: '',
      serialnumberText: '',
      serialnumberTextNew: '',
      productNameTextNew: '',
      productModelcodeTextNew: '',
      returnType: 0,
      titleDateChange: 'Ngày đổi',
      titleReasonChange: 'Lý do đổi',
      serviceType: '',
      dateChange: '',
      reasonChange: '',
      reasonDetail: '',
      serial_number_id: 0,
      request_activation_id: 0,
      change_serial_number_product_id: 0,
      change_request_activation_id: 0,
      displayDialog: false,
      dialogHeader: '',
      model_code_dialog: '',
      product_name_dialog: '',
      serial_number: '',
      categories_name: '',
      created_date: '',
      date_of_sale: '',
      activation_date: '',
      expired_activation_date: '',
      warranty_status: '',
      warranty_time: '',
      warranty_unit:'',
      returnable_time: '',
      change_time: '',
      organization_id: 0
    }
  },
  async mounted () {
    if (this.$route.params.id !== undefined && !isNaN(this.$route.params.id)) {
      this.request_return_product_id = Number(this.$route.params.id);
      await this.getData();
    }
    if (this.$route.query.id !== undefined && !isNaN(this.$route.query.id)) {
      this.request_id = Number(this.$route.query.id);
    }
    if (this.$route.query.user !== undefined && !isNaN(this.$route.query.user)) {
      this.user_id = Number(this.$route.query.user);
    }
  },
  methods: {
    async getData() {
      var modelName = 'request_return_product';
      var variables = {
        where_key: {
          id: {'_eq': this.request_return_product_id }
        }
      }
      var data = await DataServices.getList(modelName, {"variables": JSON.stringify(variables), 'fields': 'return_type serial_number_id request_activation_id  change_serial_number_id change_request_activation_id  created_date reason_detail setting_reason_reject { reason_name } serial_number_product { product_serial_number { serial_number product { model_code name } } } change_serial_number_product { product_serial_number { serial_number product { model_code name }} }'});
      var list = data[Object.keys(data)];
      if (list != undefined && list != null && Object.keys(list).length > 0) {
        var records = list[0];
        this.serial_number_id  = records.serial_number_id;
        this.request_activation_id = records.request_activation_id;
        this.change_serial_number_product_id = records.change_serial_number_id;
        this.change_request_activation_id = records.change_request_activation_id;
        this.returnType = records.return_type;
        this.title = 'Chi tiết thông tin đổi';
        this.title_return = 'THÔNG TIN ĐỔI';
        this.titleDateChange = 'Ngày đổi';
        this.titleReasonChange = 'Lý do đổi';
        if (this.returnType > 0) {
          this.title = 'Chi tiết thông tin trả';
          this.title_return = 'THÔNG TIN TRẢ';
          this.titleDateChange = 'Ngày trả';
          this.titleReasonChange = 'Lý do trả';
        }
        this.serviceType = this.returnType > 0 ? 'Trả sản phẩm' : 'Đổi sản phẩm';
        this.dateChange = moment.tz(records.created_date, this.$myConstants.timeZone()).format('DD/MM/YYYY');
        this.reasonChange = (records.setting_reason_reject != undefined && records.setting_reason_reject != null && records.setting_reason_reject.reason_name != undefined) ? records.setting_reason_reject.reason_name : '';
        this.reasonDetail = records.reason_detail;

        var serialNumberData = (records.serial_number_product != undefined && records.serial_number_product != null && records.serial_number_product.product_serial_number != undefined && records.serial_number_product.product_serial_number != null) ? records.serial_number_product.product_serial_number : null;
        if (serialNumberData != null) {
          this.serialnumberText = serialNumberData.serial_number;
          this.model_code = (serialNumberData.product != undefined && serialNumberData.product != null && serialNumberData.product.model_code != undefined) ? serialNumberData.product.model_code : '';
          this.product_name = (serialNumberData.product != undefined && serialNumberData.product != null && serialNumberData.product.name != undefined) ? serialNumberData.product.name : '';
        }

        var serialNumberChangeData = (records.change_serial_number_product != undefined && records.change_serial_number_product != null && records.change_serial_number_product.product_serial_number != undefined && records.change_serial_number_product.product_serial_number != null) ? records.change_serial_number_product.product_serial_number : null;
        if (serialNumberChangeData != null) {
          //console.log("serialNumberChangeData:",serialNumberChangeData)
          this.serialnumberTextNew = serialNumberChangeData.serial_number;
          this.productNameTextNew = (!this.$myConstants.isEmpty(serialNumberChangeData.product)) ? serialNumberChangeData.product.name:'';
          this.productModelcodeTextNew = (!this.$myConstants.isEmpty(serialNumberChangeData.product)) ?  serialNumberChangeData.product.model_code:'';
        }
      }
      await this.getDataLog();
    },
    async serialNumberInfo(serialNumberID, requestActivationID, dialogTitle) {
      this.$store.commit('setDataLoading', {content: 'Đang tải dữ liệu', icon: true});
      this.$store.commit('setLoading', true);
      this.date_of_sale = '';
      this.activation_date = ''
      this.expired_activation_date = ''
      this.dialogHeader = dialogTitle;
      var name = 'product_serial_number_info_log_changed';
      var variables = {
        where_key: {
          serial_number_id: {'_eq': serialNumberID },
          request_activation_id: {'_eq': requestActivationID}
        },
        orderBy: {
          id: 'desc'
        },
        limit: 1
      }
     //requestActivationID
      var data = await DataServices.getList(name, {"variables": JSON.stringify(variables), "fields": " serial_number_id  modifier_id new_value modified_date product_serial_number { serial_number  product { model_code name categories { name }}}"});
      var list = data[Object.keys(data)];
      if (list != null && list.length) {
        
        this.listData = list[0];
        var productSerialNumber = (this.listData.product_serial_number != undefined && this.listData.product_serial_number != null) ? this.listData.product_serial_number: null;
        if (productSerialNumber != null) {
          this.serial_number = productSerialNumber.serial_number;
          var product = (productSerialNumber.product != undefined && productSerialNumber.product != null) ? productSerialNumber.product : null;
          if (product != null) {
            this.model_code_dialog = product.model_code;
            this.product_name_dialog = product.name;
            this.categories_name = (product.categories != undefined && product.categories != null) ? product.categories.name : '';
          }
        }
        var warranty_status_number = -1;
        var activationDate = '';
        var newValue = this.listData.new_value;
        if (newValue != '') {
          var json = JSON.parse(newValue);
         
          this.returnable_time = (json.returnable_time != undefined && json.returnable_time != null) ? json.returnable_time : 0;
          this.change_time = (json.change_time != undefined && json.change_time != null) ? json.change_time : 0;
          this.warranty_time = (json.warranty_time != undefined && json.warranty_time != null) ? json.warranty_time : '';
          this.warranty_unit = (json.warranty_unit != undefined && json.warranty_unit != null) ? json.warranty_unit : '';
          this.warranty_activation_time = this.warranty_time;
          var map_warranty_unit = (this.$dataCommon.COVERT_UNIT_MOMMENT[this.warranty_unit]) ? this.$dataCommon.COVERT_UNIT_MOMMENT[this.warranty_unit]:'M';
          if(json.date_of_sale != null  && json.warranty_status !== 0 && (json.warranty_status == 2 || json.warranty_status == 3 || json.warranty_status == 4 || json.warranty_status == 5)) {
            this.date_of_sale = moment.tz(json.date_of_sale, this.$myConstants.timeZone()).format('DD/MM/YYYY');
          }
          if(json.modified_date != null) {
            this.created_date = moment.tz(json.modified_date, this.$myConstants.timeZone()).format('DD/MM/YYYY');
          } else if(json.created_date != null) {
            this.created_date = moment.tz(json.created_date, this.$myConstants.timeZone()).format('DD/MM/YYYY');
          }

          if(json.activation_date != null && json.warranty_time != null && (json.warranty_status == 3 || json.warranty_status == 4 || json.warranty_status == 5)) {
            activationDate = json.activation_date;
            this.expired_activation_date = moment(json.activation_date).add(this.warranty_time, map_warranty_unit);
            this.expired_activation_date = moment.tz(this.expired_activation_date, this.$myConstants.timeZone()).format('DD/MM/YYYY');
            this.activation_date =  moment.tz(json.activation_date, this.$myConstants.timeZone()).format('DD/MM/YYYY');
          }
          warranty_status_number = json.warranty_status;
        }
       

        // // this.serial_number = this.listData.product_serial_number.serial_number;
        // // this.activation_date = this.listData.activation_date;
        
        
        if (warranty_status_number == 2) this.warranty_status = '<abbr style="padding: 2px 10px; border-radius: 5px; color:#fff; background: rgb(153, 0, 204); font-style: normal;">Chờ kích hoạt</abbr>';
        else if (warranty_status_number == 0) this.warranty_status = '<abbr style="padding: 2px 10px; border-radius: 5px; font-style: normal;color:#fff; background: rgba(255, 102, 0, 1);">Chưa kích hoạt</abbr>';
        else if (warranty_status_number == 5) this.warranty_status = '<abbr style="padding: 2px 10px; border-radius: 5px; font-style: normal;color:#fff; background: rgba(204, 0, 0, 1);">Tắt kích hoạt</abbr>';
        else if (warranty_status_number == 4) this.warranty_status = '<abbr style="padding: 2px 10px; border-radius: 5px; color:#fff; background: rgb(51, 0, 204);font-style: normal;">Hết bảo hành</abbr>';
        else if (warranty_status_number == 6) this.warranty_status = '<abbr style="padding: 2px 10px; border-radius: 5px; color:#fff; background: rgb(0, 0, 0);font-style: normal;">Sản phẩm huỷ</abbr>';
        else if (warranty_status_number == 3 || warranty_status_number == 1) this.warranty_status = '<abbr style="padding: 2px 10px; border-radius: 5px; color:#fff; font-style: normal; background: rgb(0, 204, 0);">Đã kích hoạt</abbr>';

        var dataDateArr = {
          warranty_time:this.warranty_time,
          returnable_time:this.returnable_time,
          change_time:this.change_time,
          warranty_status:warranty_status_number,
          activation_date:activationDate,
          arrWarrantyStatus:[5],
          warranty_unit:this.warranty_unit
        }
        var arrs =  this.$myConstants.returnDateCustomText(dataDateArr);
        
        this.warranty_time = arrs.warranty_time_text;
        this.returnable_time = arrs.returnable_time_text;
        this.change_time = arrs.change_time_text;

        this.$store.commit('setLoading', false);
        this.displayDialog = true;
      }
    },
    async getDataLog() {
      var nameLog = 'request_return_product_process';
      this.dataModelLog = DataServices.getModel(nameLog);
      if (this.request_return_product_id > 0) {
        var variables = {
          where_key: {
            request_return_product_id: {'_eq': this.request_return_product_id}
          },
          orderBy: {
            id: 'desc'
          }
        }
        var data = await DataServices.getList(nameLog, {"variables": JSON.stringify(variables)});
        var list = data[Object.keys(data)];
        this.dataModelLog.processData(list);
        this.listDataLog = list;
        this.componentKeyLog++;
      }
    },
    backList() {
      if (this.$route.query && this.$route.query != null && Object.entries(this.$route.query).length) {
        var params = {};
        if(this.request_id> 0) {
          params = Object.assign(params, {id: this.request_id});
        }
        if(this.user_id > 0) {
          params = Object.assign(params, {user: this.user_id});
        }
        this.$router.push({name: 'appraisal_product_function', params: params});
      } else {
        this.$router.go(-1);
      }
    }
  }
}
</script>
<style lang="scss">
.box-top-list{ margin-bottom: 0px; position: relative;
  &.last-changed{margin-top: 30px;margin-bottom: 15px; padding: 0 20px;}
  span{font-size: 20px; text-align: left; }
  .right-button{
    &.view-detail{position: absolute; right: 20px; top: -3px; margin-bottom: 10px;}
  }
  &.box-info-product{margin-bottom: 10px; margin-top: 20px;
    .right-button{ position: relative; top: -12px;
      .p-button-edit{border-radius: 50%; height: 2.357rem; width: 2.357rem; padding: 0.5rem 0; margin: 0 !important;}
    }
  }
  .format-title{font-weight: bold; font-size: 16px;}
}
.box-info{ padding: 0 20px;
  &.list-product{margin-bottom: 30px;}
  .box-info-title{ font-size: 16px; font-weight: 700; margin-bottom: 10px; margin-top: 20px;}
  .box-invoice-img{
    img{margin-right: 20px;
      &:last-child{margin: 0;}
    }
  }
  .form-info{
    .p-field{ padding: 10px;display: flex;
      &:nth-child(n) {background: #E4E4E4;}
      &:nth-child(2n) {background: #fff;}
      label{ width: 200px; margin: 0;}
      span {display: inline-flex; width: calc(100% - 220px);
        abbr{margin-left: 5px; color: #0066FF; font-style: italic; font-weight: 500; cursor: pointer;}
        .timeline{font-weight: bold; font-style: italic; padding-left: 5px; color: #333;}
      }
    }
  }
  &.form-popup-custom{
    .form-info{
      .p-field{
         label{ width: 250px; margin: 0;}
      }
    }
  }
  .btn-function {margin-top: 15px;
    button{width: 170px; margin-right: 15px;}
  }
}
.box-reason{ padding: 10px 20px;
}
.popup-confirm{
  .p-dialog-header {
     span{font-weight: bold !important; color: #666666 !important;}
  }
}

.custom-error{display: block; color: #f00; margin-top: 10px;}
.box-list-img{
  .item{position: relative; width: 100px; 
    .remove-icon{position: absolute; right: -3px; color: #fff; background: #f00; width: 15px; height: 15px; overflow: hidden; border-radius: 50%;
      span{color: #fff; font-size: 8px; position: relative;top: -7px; left: 4px; font-weight: bold;}
    }
    .img {padding-top: 6px;
      img{max-width: 100%; height: auto;}
    }
  }
}
.edit-time-product{ margin-bottom: 20px;
  .p-inputtext{margin-right: 100px;}
  .p-inputgroup-addon{color:#333; background: transparent; border: 0 none; text-align: right; flex: auto; justify-content: flex-end;}
}
.images-wrapper { display: flex;
  .image {height: 150px; width: 100px; display: block; margin-right: 20px; cursor: pointer; background-size: contain; background-repeat: no-repeat;
    &:last-child{margin: 0;}
  }
}
.timeline{ font-weight: bold; font-style: italic; padding-left: 5px;}
</style>